import { render, staticRenderFns } from "./SummaryCopy.vue?vue&type=template&id=32d698d2&scoped=true&lang=pug"
import script from "./SummaryCopy.vue?vue&type=script&lang=js"
export * from "./SummaryCopy.vue?vue&type=script&lang=js"
import style0 from "./SummaryCopy.vue?vue&type=style&index=0&id=32d698d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d698d2",
  null
  
)

export default component.exports